import { render, staticRenderFns } from "./PriceCardViewTitle.vue?vue&type=template&id=e94e51d4&scoped=true"
import script from "./PriceCardViewTitle.vue?vue&type=script&lang=ts"
export * from "./PriceCardViewTitle.vue?vue&type=script&lang=ts"
import style0 from "./PriceCardViewTitle.vue?vue&type=style&index=0&id=e94e51d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94e51d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94e51d4')) {
      api.createRecord('e94e51d4', component.options)
    } else {
      api.reload('e94e51d4', component.options)
    }
    module.hot.accept("./PriceCardViewTitle.vue?vue&type=template&id=e94e51d4&scoped=true", function () {
      api.rerender('e94e51d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/prices/PriceCardViewTitle.vue"
export default component.exports